var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSilverSeller = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07103 19.5093L0 27.7014L5.60661 26.2957L8.05967 31.7066L11.9096 23.9594L9.51023 22.6591L6.1105 22.5675L4.33127 19.669L4.07103 19.5093Z",
    fill: "#9196A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4966 23.7396L17.481 31.7574L19.934 26.3464L25.5406 27.7521L21.3241 19.2671L20.6693 19.669L18.8901 22.5675L15.4904 22.6591L13.4966 23.7396Z",
    fill: "#9196A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1911 1.45824L12.5004 0L9.8097 1.45824L6.75038 1.54071L5.1493 4.14892L2.54109 5.75L2.45862 8.80932L1.00038 11.5L2.45862 14.1907L2.54109 17.25L5.1493 18.8511L6.75038 21.4593L9.8097 21.5418L12.5004 23L15.1911 21.5418L18.2504 21.4593L19.8515 18.8511L22.4597 17.25L22.5421 14.1907L24.0004 11.5L22.5421 8.80932L22.4597 5.75L19.8515 4.14892L18.2504 1.54071L15.1911 1.45824ZM16.9424 3.80628L14.579 3.74257L12.5004 2.61606L10.4218 3.74257L8.05841 3.80628L6.82155 5.82117L4.80667 7.05803L4.74296 9.4214L3.61644 11.5L4.74296 13.5786L4.80667 15.942L6.82155 17.1788L8.05841 19.1937L10.4218 19.2574L12.5004 20.3839L14.579 19.2574L16.9424 19.1937L18.1792 17.1788L20.1941 15.942L20.2578 13.5786L21.3843 11.5L20.2578 9.4214L20.1941 7.05803L18.1792 5.82117L16.9424 3.80628Z",
    fill: "#9196A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5004 5L14.3878 8.90225L18.6823 9.49139L15.5542 12.4923L16.321 16.7586L12.5004 14.711L8.67978 16.7586L9.44654 12.4923L6.31852 9.49139L10.613 8.90225L12.5004 5Z",
    fill: "#9196A4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSilverSeller);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-silver-seller.93e6dc3743560791a1734e311eff1b25.svg";